import { useSwiper } from "swiper/react";

export default function SlidePrevButton() {
  const swiper = useSwiper();

  return (
    <div
      className="swiper-arrows swiper-prev"
      onClick={() => swiper.slidePrev()}
    ></div>
  );
}
